export enum DROP_FILE_AREA {
	DROP_ACTIVATED = 'Drop the files here ...',
	DROP_AREA_TEXT = 'Drag and drop or',
	CHOOSE_FILE = 'choose file',
	CHOOSE_FILES = 'choose files',
}
export const LARGE_FILE_ERROR = (
	maxfileSize: number,
) => `The file exceeds ${maxfileSize}MB in size. Please verify that your
    file is no larger than ${maxfileSize}MB.`;
export const MAX_FILE_LIMIT_ERROR = (
	maxFilesLimit: number,
) => `I can only process up to ${
	maxFilesLimit === 1 ? `1 file` : `${maxFilesLimit} files`
} per session. Please
					attempt the upload again.`;
